import { createFileRoute } from '@tanstack/react-router';
import EvidencePackViewerPage from '@/pages/(protected)/workspaces/[workspaceId]/evidence-viewer/[evidencePackId]';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
)({
  component: EvidencePackViewerPage,
});
